// --- Types ---

export interface BundleCardType {
    id: string | number;
    product: string;
    subtitle: string;
    productId: string;
    processType: string;
    categories: string[];
    documents: string[];
    onEdit: () => void;
}

export interface BundleSection {
    sectionTitle: string;
    cards: BundleCardType[];
}

export enum BundleDocumentType {
    Static = 1,
    Template = 2,
    Personal = 3
}
